import React, { Component } from 'react';
import mergeStyle from '../utils/StyleMerge';
import { Container } from 'reactstrap';

class ListItem extends Component {
  render() {
    const {
      index,
      item,
      render,
      styles
    } = this.props;
    return (
      /*#__PURE__*/
      React.createElement("div", {
        style: styles.container
      }, render(item, index))
    );
  }

}

const defaultStyles = {
  container: {}
};
export default mergeStyle(defaultStyles)(ListItem);